import {SessionTextChatBase} from './SessionTextChatBase';
import {SessionTextChatProps} from './types';

import './styles.scss';

export const SessionTextChat: React.FC<SessionTextChatProps> = (props: SessionTextChatProps) =>
    <SessionTextChatBase {...props} />;
